(function() {
  'use strict';

  function initSizeSlider(container) {
    const sliderWrap = container || document.querySelector(".sld-wrap");
    if (!sliderWrap) return;
    
    // Check if already initialized
    const isAlreadyInitialized = sliderWrap.hasAttribute('data-slider-initialized');
    if (isAlreadyInitialized) {
     // console.log('[Size Slider] Already initialized, skipping');
      return;
    }
    
    // Find the .toggle-ellipsis__content INSIDE this sliderWrap
    const toggleEllipsisContent = sliderWrap.querySelector('.toggle-ellipsis__content');
    if (!toggleEllipsisContent) {
     // console.warn('[Size Slider] .toggle-ellipsis__content not found inside this slider');
      return;
    }

    const radioButtonsWrapper = sliderWrap.querySelector(".radio__buttons");
    if (!radioButtonsWrapper) return;
    
    // Find arrows (added by Liquid when options > 5)
    const prevBtn = toggleEllipsisContent.querySelector('[data-slider-prev]');
    const nextBtn = toggleEllipsisContent.querySelector('[data-slider-next]');
    
    if (!prevBtn || !nextBtn) {
     // console.log('[Size Slider] No arrows found - option count <= 5');
      return;
    }
    
    //console.log('[Size Slider] Initializing CSS-based slider with smart scrolling');
    
    // Calculate how many full buttons fit in the visible area
    const getVisibleButtonCount = () => {
      const containerWidth = radioButtonsWrapper.offsetWidth;
      const buttons = radioButtonsWrapper.querySelectorAll('.radio__button');
      if (buttons.length === 0) return 1;
      
      // Get the width of first button + margin
      const firstButton = buttons[0];
      const buttonStyle = window.getComputedStyle(firstButton);
      const buttonWidth = firstButton.offsetWidth;
      const marginRight = parseInt(buttonStyle.marginRight) || 0;
      const totalButtonWidth = buttonWidth + marginRight;
      
      // How many full buttons fit?
      const fullButtonsFit = Math.floor(containerWidth / totalButtonWidth);
      return Math.max(1, fullButtonsFit);
    };
    
    // Scroll by full buttons
    const scrollByButtons = (direction) => {
      const buttons = radioButtonsWrapper.querySelectorAll('.radio__button');
      if (buttons.length === 0) return;
      
      const visibleCount = getVisibleButtonCount();
      const currentScroll = radioButtonsWrapper.scrollLeft;
      
      // Get button width
      const buttonStyle = window.getComputedStyle(buttons[0]);
      const buttonWidth = buttons[0].offsetWidth + (parseInt(buttonStyle.marginRight) || 0);
      
      // Calculate scroll amount (scroll by visible count)
      const scrollAmount = buttonWidth * visibleCount;
      
      if (direction === 'prev') {
        radioButtonsWrapper.scrollTo({
          left: currentScroll - scrollAmount,
          behavior: 'smooth'
        });
      } else {
        radioButtonsWrapper.scrollTo({
          left: currentScroll + scrollAmount,
          behavior: 'smooth'
        });
      }
    };
    
    // Update arrow states based on scroll position
    const updateArrowStates = () => {
      const scrollLeft = radioButtonsWrapper.scrollLeft;
      const maxScroll = radioButtonsWrapper.scrollWidth - radioButtonsWrapper.offsetWidth;
      
      // Disable prev arrow at start
      if (scrollLeft <= 1) {
        prevBtn.style.opacity = '0.3';
        prevBtn.style.pointerEvents = 'none';
      } else {
        prevBtn.style.opacity = '1';
        prevBtn.style.pointerEvents = 'auto';
      }
      
      // Disable next arrow at end
      if (scrollLeft >= maxScroll - 1) {
        nextBtn.style.opacity = '0.3';
        nextBtn.style.pointerEvents = 'none';
      } else {
        nextBtn.style.opacity = '1';
        nextBtn.style.pointerEvents = 'auto';
      }
    };
    
    // Scroll to the selected option: use legend's displayed value as source of truth
    // so we scroll to the correct option even if multiple radios are mistakenly checked
    const scrollToSelectedOption = () => {
      const fieldset = sliderWrap.closest('fieldset');
      const selectedValueEl = fieldset && fieldset.querySelector('[data-selected-value]');
      const selectedValue = selectedValueEl ? (selectedValueEl.textContent || '').trim() : '';
      let selectedButton = null;
      if (selectedValue) {
        const radios = radioButtonsWrapper.querySelectorAll('input[type="radio"]');
        for (let i = 0; i < radios.length; i++) {
          if (radios[i].value === selectedValue) {
            selectedButton = radios[i].closest('.radio__button');
            break;
          }
        }
      }
      if (!selectedButton) {
        const selectedRadio = radioButtonsWrapper.querySelector('input[type="radio"]:checked');
        if (selectedRadio) selectedButton = selectedRadio.closest('.radio__button');
      }
      if (selectedButton) {
        const containerWidth = radioButtonsWrapper.offsetWidth;
        const buttonLeft = selectedButton.offsetLeft;
        const buttonWidth = selectedButton.offsetWidth;
        const scrollPosition = buttonLeft - (containerWidth / 2) + (buttonWidth / 2);
        radioButtonsWrapper.scrollTo({
          left: Math.max(0, scrollPosition),
          behavior: 'smooth'
        });
        setTimeout(updateArrowStates, 100);
      }
    };
    
    // Attach click handlers
    prevBtn.addEventListener('click', () => scrollByButtons('prev'));
    nextBtn.addEventListener('click', () => scrollByButtons('next'));
    
    // Update arrow states on scroll
    radioButtonsWrapper.addEventListener('scroll', updateArrowStates);
    
    // Initial arrow state
    updateArrowStates();
    
    // Scroll to selected option if exists
    scrollToSelectedOption();

    // Mark as initialized
    sliderWrap.setAttribute('data-slider-initialized', 'true');
    console.log('[Size Slider] ✓ CSS slider initialized with smart scrolling');
  }

  function reinitializeSliders() {
    // Find all .sld-wrap elements and initialize them
    const sliderWraps = document.querySelectorAll('.sld-wrap');
    sliderWraps.forEach(wrap => {
      // Remove old initialization flag
      wrap.removeAttribute('data-slider-initialized');
      
      // Initialize fresh
      initSizeSlider(wrap);
    });
  }

  // Initialize on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reinitializeSliders);
  } else {
    reinitializeSliders();
  }

  // Watch for changes in variant-selects and re-initialize
  let reinitTimer;
  const observer = new MutationObserver(function(mutations) {
    let shouldReinit = false;
    let hasNewSliderWrap = false;
    
    mutations.forEach(function(mutation) {
      // Check if any added nodes contain or are .sld-wrap
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === 1) { // Element node
          if (node.classList && node.classList.contains('sld-wrap')) {
            hasNewSliderWrap = true;
            shouldReinit = true;
          } else if (node.querySelector && node.querySelector('.sld-wrap')) {
            hasNewSliderWrap = true;
            shouldReinit = true;
          }
        }
      });
      
      // Also check if existing .sld-wrap was removed (need to clean up)
      mutation.removedNodes.forEach(function(node) {
        if (node.nodeType === 1) {
          if (node.classList && node.classList.contains('sld-wrap')) {
            shouldReinit = true;
          } else if (node.querySelector && node.querySelector('.sld-wrap')) {
            shouldReinit = true;
          }
        }
      });
    });

    if (shouldReinit) {
      console.log('[Size Slider] Detected .sld-wrap change, checking sliders...');
      // Debounce to avoid multiple rapid reinits
      clearTimeout(reinitTimer);
      reinitTimer = setTimeout(reinitializeSliders, hasNewSliderWrap ? 100 : 50);
    }
  });

  // Start observing the entire product area
  function startObserving() {
    const productInfo = document.querySelector('product-info');
    const variantSelects = document.querySelector('variant-selects');
    
    if (productInfo) {
      observer.observe(productInfo, { 
        childList: true, 
        subtree: true 
      });
     // console.log('[Size Slider] Observing product-info for changes');
    } else if (variantSelects) {
      observer.observe(variantSelects, { 
        childList: true, 
        subtree: true 
      });
      //console.log('[Size Slider] Observing variant-selects for changes');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserving);
  } else {
    startObserving();
  }
})();
